module.exports = __webpack_public_path__ + "static/a-short-guide-to-a-happy-life-33e0c0585d38701fa6166957aea1edcb.jpg";